
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace, Action } from 'vuex-class';
import { Ability } from '@casl/ability';
import type { EnvConfig } from '@license-manager/types';

const envconfig = namespace('envconfig');

@Component({
  components: {},
  name: 'VersionInfo',
})
export default class VersionInfo extends Vue {
  @Prop({ default: true })
  showVersion: boolean;

  @Prop({ default: true })
  showBanner: boolean;

  @envconfig.Action('loadEnvConfig') loadEnvConfig: () => Promise<any>;

  @envconfig.Getter
  activeEnvConfig: EnvConfig;

  @envconfig.Getter
  showEnvBanner: boolean;

  async mounted() {
    await this.loadEnvConfig();
  }
}
